import { AspectRatio, Box, Text, VStack, Flex } from '@chakra-ui/react'
import Image from 'next/image'

const Recommendation = () => {
  return (
    <VStack alignItems="center" my={20}>
      <Text
        data-aos="fade-up"
        textStyle="oralcareOptimizingTitle"
        textAlign="center"
        w={{
          base: '90%',
          sm: '600px'
        }}
        mt={{
          base: '1px',
          sm: '10px',
          md: '10px',
          lg: '10px'
        }}
      >
        Our Recommendation for Targeted Oral Care Solutions
      </Text>

      <AspectRatio
        data-aos="fade-up"
        w={{
          base: '100%',
          sm: '100%',
          xl: '600px'
        }}
        ratio={906 / 694}
        position="relative"
      >
        <Image
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/recommendation-target-1714039067794.png'
          }
          alt="recommendation target"
          fill
        />
      </AspectRatio>

      <Flex
        data-aos="fade-up"
        w={{
          base: '100%',
          md: 700,
          lg: 800
        }}
        gap={{
          base: 4,
          sm: 4,
          md: 6
        }}
        mt={10}
        flexDir={{
          base: 'column',
          md: 'row'
        }}
      >
        <VStack
          w={{
            base: '100%',
            md: '40%'
          }}
        >
          <AspectRatio
            w={{
              base: '100%',
              md: '100%'
            }}
            ratio={1306 / 862}
            position="relative"
          >
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/smile-teeth-1714039067795.png'
              }
              alt="smile teeth"
              fill
            />
          </AspectRatio>
          <AspectRatio
            w={{
              base: '90%',
              md: '90%'
            }}
            ratio={1537 / 864}
            position="relative"
          >
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/after-before-1714039067795.png'
              }
              alt="after before"
              fill
            />
          </AspectRatio>
        </VStack>
        <Box
          w={{
            base: '100%',
            md: '55%'
          }}
        >
          <Text
            fontSize={{
              base: '12px',
              sm: '16px',
              md: '18px',
              lg: '20px'
            }}
            lineHeight={{
              base: 1.3,
              md: 1.4
            }}
            textAlign="left"
            fontWeight={400}
            zIndex={100}
            mt="-6px"
          >
            Introducing <strong> Health+ OralCare Mouthwash</strong>, formulated
            with essential components to uphold optimal oral and dental hygiene.
            <br /> <br />
            Our advanced formula <strong>targets</strong> and
            <strong> eliminates</strong> eliminates harmful oral bacteria,
            effectively <strong> preventing </strong> the buildup of detrimental
            substances in the mouth, thus ensuring sustained oral health. <br />
            <br />
            Furthermore, enriched with <strong>xylitol</strong>, our mouthwash
            not only enhances oral freshness but also stimulates salivation,
            contributing to overall oral wellness.
          </Text>
        </Box>
      </Flex>
    </VStack>
  )
}

export default Recommendation
